var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"py-10",attrs:{"padless":"","dark":""}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_vm._v("\n        © "+_vm._s(new Date().getFullYear())+" — Ravenpod, Inc. - All rights reserved.\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }